module.exports = __webpack_public_path__ + "media/tadaima.ae2ae341.mp3";